module.exports = __webpack_public_path__ + "static/img/アセット 76@3x.27d884c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 76@3x.png
// module id = W68v
// module chunks = 1